import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { BASE_URL } from "../constants/constant";
import { Service } from "../services/service";

const service = new Service();

export const initialState = {
  allVfUsers: [],
  loading: false,
  status: null,
  isPackageAdded: false,
  currentTrend: null,
};

export const getAllVfUsers = createAsyncThunk(
  "get-all-vf-users",
  async (obj) => {
    const url = `${BASE_URL}/api/User/GetAllVFAdmins`;
    const params = obj;
    const user_token = localStorage.getItem("bb_access_token");
    const response = await service.testGetApi(url, params, user_token);
    const data = response.data;
    return data;
  }
);

export const createVfUser = createAsyncThunk(
  "create-vf-user",
  async ({ data }) => {
    let url = `/api/User/AddVFAdmin`;
    data = JSON.stringify(data);
    const user_token = localStorage.getItem("bb_access_token");
    let response = await service.newPostApi(url, data, user_token);
    return response;
  }
);

const vfuserSlice = createSlice({
  name: "vfuser",
  initialState,
  reducers: {
    updateCurrentTrend(state, action) {
      state.currentTrend = action.payload;
    },
  },
  extraReducers: {
    [getAllVfUsers.pending]: (state) => {
      state.loading = true;
    },
    [getAllVfUsers.fulfilled]: (state, { payload }) => {
      state.allVfUsers = payload;
      state.loading = false;
    },
    [getAllVfUsers.rejected]: (state) => {
      state.allVfUsers = [];
      state.loading = false;
    },
    [createVfUser.pending]: (state) => {
      state.loading = true;
    },
    [createVfUser.fulfilled]: (state, { payload }) => {
      state.status = payload.response.status;
      state.loading = false;
      state.isPackageAdded = true;
    },
    [createVfUser.rejected]: (state) => {
      state.loading = false;
    },
  },
});

export const { updateCurrentTrend } = vfuserSlice.actions;
export default vfuserSlice.reducer;
